// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"e8d42d0c","159":"d34d6f84","418":"07671b58","520":"8a8d049c","553":"1f4a21b6","692":"8b73ea87","827":"2e7edac0","845":"ac429a08","862":"dc26b457","895":"751bdb53","970":"72651489","976":"c33eb263"}[chunkId] + ".chunk.js";
};